/* Scent Select page: snap slides, roster, class filters, random pick, Press Start screen, optional sound. */
(function () {
  var root = document.querySelector('[data-ss]');
  if (!root || root.__ssReady) return;
  root.__ssReady = true;

  var track = root.querySelector('[data-ss-track]');
  var slides = [].slice.call(root.querySelectorAll('[data-ss-slide]'));
  var thumbs = [].slice.call(root.querySelectorAll('[data-ss-thumb]'));
  var tabs = [].slice.call(root.querySelectorAll('[data-ss-filter]'));
  var roster = root.querySelector('[data-ss-roster]');
  var counter = root.querySelector('[data-ss-count]');
  var totalEl = root.querySelector('[data-ss-total]');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var current = -1;
  var vis = slides.map(function (s, k) { return k; }); // indexes of slides in the current filter

  // Optional sound: off by default, soft blips made with Web Audio (no audio files). The choice is remembered.
  var soundBtn = root.querySelector('[data-ss-sound]');
  var soundOn = false;
  var audioCtx = null;
  try { soundOn = localStorage.getItem('ss-sound') === '1'; } catch (err) { /* storage blocked */ }
  var SOUNDS = {
    move: [[660, 0, 0.05, 'triangle', 0.05]],
    roll: [[880, 0, 0.03, 'square', 0.02]],
    select: [[523, 0, 0.09, 'triangle', 0.07], [659, 0.07, 0.09, 'triangle', 0.07], [784, 0.14, 0.16, 'triangle', 0.07]],
    start: [[392, 0, 0.1, 'triangle', 0.06], [523, 0.09, 0.1, 'triangle', 0.06], [784, 0.18, 0.22, 'triangle', 0.06]]
  };
  function play(name) {
    if (!soundOn) return;
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    if (!audioCtx) audioCtx = new AC();
    if (audioCtx.state === 'suspended') audioCtx.resume();
    var t = audioCtx.currentTime;
    SOUNDS[name].forEach(function (n) {
      var osc = audioCtx.createOscillator();
      var gain = audioCtx.createGain();
      osc.type = n[3];
      osc.frequency.value = n[0];
      gain.gain.setValueAtTime(0.0001, t + n[1]);
      gain.gain.exponentialRampToValueAtTime(n[4], t + n[1] + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + n[1] + n[2]);
      osc.connect(gain);
      gain.connect(audioCtx.destination);
      osc.start(t + n[1]);
      osc.stop(t + n[1] + n[2] + 0.02);
    });
  }
  function setSound(on) {
    soundOn = on;
    if (soundBtn) {
      soundBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      soundBtn.setAttribute('aria-label', on ? 'Sound on' : 'Sound off');
    }
    try { localStorage.setItem('ss-sound', on ? '1' : '0'); } catch (err) { /* storage blocked */ }
    play('select');
  }
  if (soundBtn) {
    soundBtn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
    soundBtn.setAttribute('aria-label', soundOn ? 'Sound on' : 'Sound off');
    soundBtn.addEventListener('click', function () { setSound(!soundOn); });
  }

  // Press Start: shown once per browser session; slides stay idle until it is dismissed.
  var intro = root.querySelector('[data-ss-intro]');
  var started = !intro;
  if (intro) {
    var seen = false;
    try { seen = sessionStorage.getItem('ss-intro-seen') === '1'; } catch (err) { /* storage blocked */ }
    if (seen || (window.Shopify && Shopify.designMode)) {
      intro.hidden = true;
      root.classList.add('is-started');
      started = true;
    }
  }
  function start() {
    if (started) return;
    started = true;
    root.classList.add('is-started');
    try { sessionStorage.setItem('ss-intro-seen', '1'); } catch (err) { /* storage blocked */ }
    play('start');
    setTimeout(function () { current = -1; setActive(vis[0]); }, reduce ? 0 : 280);
    setTimeout(function () { intro.hidden = true; }, reduce ? 0 : 800);
  }
  if (intro && !started) {
    intro.addEventListener('click', start);
    intro.addEventListener('wheel', start, { passive: true });
    intro.addEventListener('touchmove', start, { passive: true });
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function setActive(i) {
    if (!started || i === current || i < 0) return;
    if (current !== -1 && !spinning) play('move');
    current = i;
    slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    thumbs.forEach(function (t, k) {
      t.classList.toggle('is-active', k === i);
      if (k === i) {
        t.setAttribute('aria-current', 'true');
        roster.scrollTo({ left: t.offsetLeft - roster.clientWidth / 2 + t.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
      } else {
        t.removeAttribute('aria-current');
      }
    });
    if (counter) counter.textContent = pad(vis.indexOf(i) + 1);
  }

  // Fill the screen below the header (the header group height varies by page).
  function fit() {
    root.style.setProperty('--ss-top', Math.max(0, root.getBoundingClientRect().top + window.scrollY) + 'px');
  }
  fit();
  window.addEventListener('resize', fit, { passive: true });

  // Remember where a smooth scroll is headed so quick repeated key presses keep going.
  var target = null;
  var targetTimer;
  function go(i) {
    if (!slides[i] || slides[i].hidden) return;
    target = i;
    clearTimeout(targetTimer);
    targetTimer = setTimeout(function () { target = null; }, 700);
    track.scrollTo({ top: slides[i].offsetTop, behavior: reduce ? 'auto' : 'smooth' });
  }
  function step(dir) {
    var pos = vis.indexOf(target === null ? current : target);
    var next = Math.max(0, Math.min(vis.length - 1, pos + dir));
    go(vis[next]);
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) setActive(slides.indexOf(e.target));
      });
    }, { root: track, threshold: 0.55 });
    slides.forEach(function (s) { io.observe(s); });
  }
  setActive(0);

  thumbs.forEach(function (t, k) {
    t.addEventListener('click', function () { go(k); });
  });

  // Class filter tabs: For him / For her also include unisex, like the collections.
  function matches(slide, cls) {
    var c = slide.getAttribute('data-class');
    if (cls === 'all') return true;
    if (cls === 'unisex') return c === 'unisex';
    return c === cls || c === 'unisex';
  }
  tabs.forEach(function (tab) {
    var cls = tab.getAttribute('data-ss-filter');
    var count = slides.filter(function (s) { return matches(s, cls); }).length;
    var small = document.createElement('small');
    small.textContent = count;
    tab.appendChild(small);
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      vis = [];
      slides.forEach(function (s, k) {
        var show = matches(s, cls);
        s.hidden = !show;
        thumbs[k].hidden = !show;
        if (show) vis.push(k);
      });
      if (totalEl) totalEl.textContent = vis.length;
      target = null;
      current = -1;
      play('move');
      track.scrollTo({ top: 0 });
      roster.scrollTo({ left: 0 });
      setActive(vis[0]);
    });
  });

  // Random: flick through bottles on the "?" tile, then land on an in-stock one.
  var randomBtn = root.querySelector('[data-ss-random]');
  var randomImg = root.querySelector('[data-ss-random-img]');
  var spinning = false;
  function showOnTile(k) {
    var img = thumbs[k].querySelector('img');
    if (img) randomImg.src = img.currentSrc || img.src;
    randomBtn.style.setProperty('--roll', thumbs[k].style.getPropertyValue('--accent'));
    thumbs.forEach(function (t, n) { t.classList.toggle('is-roll', n === k); });
  }
  function random() {
    if (spinning) return;
    var pool = vis.filter(function (k) { return k !== current && !slides[k].classList.contains('is-locked'); });
    if (!pool.length) return;
    var pick = pool[Math.floor(Math.random() * pool.length)];
    if (reduce) { go(pick); return; }
    spinning = true;
    root.classList.add('is-spinning');
    var steps = 12;
    var n = 0;
    (function tick() {
      n++;
      play('roll');
      showOnTile(n === steps ? pick : vis[Math.floor(Math.random() * vis.length)]);
      if (n < steps) { setTimeout(tick, 40 + n * n * 1.2); return; }
      setTimeout(function () {
        root.classList.remove('is-spinning');
        thumbs.forEach(function (t) { t.classList.remove('is-roll'); });
        spinning = false;
        go(pick);
      }, 260);
    })();
  }
  if (randomBtn) randomBtn.addEventListener('click', random);

  document.addEventListener('keydown', function (e) {
    if (document.documentElement.classList.contains('no-scroll')) return;
    var tag = (e.target.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || tag === 'select') return;
    if (!started) {
      if (e.ctrlKey || e.metaKey || e.altKey || e.key === 'Tab' || e.key === 'Shift') return;
      e.preventDefault();
      start();
      return;
    }
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight' || e.key === 'PageDown') { e.preventDefault(); step(1); }
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft' || e.key === 'PageUp') { e.preventDefault(); step(-1); }
    else if ((e.key === 'r' || e.key === 'R') && !e.ctrlKey && !e.metaKey && !e.altKey) { e.preventDefault(); random(); }
    else if ((e.key === 'm' || e.key === 'M') && !e.ctrlKey && !e.metaKey && !e.altKey) { e.preventDefault(); setSound(!soundOn); }
    else if (e.key === 'Enter' && (e.target === document.body || e.target === document.documentElement)) {
      var btn = slides[current] && slides[current].querySelector('.ss-select');
      if (btn && !btn.disabled) { e.preventDefault(); btn.click(); }
    }
  });

  // Flash + "Selected" pop; theme.js does the actual add to bag (data-quick-add).
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('.ss-select');
    if (!btn || btn.disabled) return;
    var slide = btn.closest('[data-ss-slide]');
    play('select');
    slide.classList.remove('is-picked');
    void slide.offsetWidth;
    slide.classList.add('is-picked');
    setTimeout(function () { slide.classList.remove('is-picked'); }, 1400);
  });
})();
